//新增配置
import i18n from '@/lang/index'
export const columns = [
    {
        prop: 'index',
        type: 'index',
        label: i18n.t('deptStock.sortIndex')
    },
    {
        prop: 'goodsNo',
        label: i18n.t('deptStock.goodsNo')
    },
    {
        prop: 'color',
        label: i18n.t('deptStock.color')
    },
    {
        prop: 'sizeInfoList',
        width: '800px',
        boxWidth: '0px' //复选框宽度
    },
    {
        prop: 'total',
        label: i18n.t('deptStock.leftStockNumber'),
        type: 'count',
        getTotal(row, _key) {
            return row.sizeInfoList.reduce((c, R) => c + Number(R[_key] ? R[_key] : 0), 0)
        }
    },
    {
        prop: 'tagPrice',
        label: i18n.t('stockDiffer.tagPrice')
    },
    {
        prop: 'typeCategory',
        label: i18n.t('stockDiffer.styleCategory')
    },
    {
        prop: 'styleCategory',
        label: i18n.t('stockDiffer.styleType')
    },
    {
        prop: 'timeCategory',
        label: i18n.t('stockDiffer.timeCategory')
    }
]

export const sizeInfoLabel = [
    {
        prop: 'scanNumber', //复选框key//valueInfoList当前行对应key
        label: '', //复选框名称及行数据对应名称
        checkShow: false, //是否出现复选框
        value: true, //绑定值
        disabled: true //禁用
    }
]
